interface Props {
  text: string | any;
}
export const HelperText = ({ text }: Props) => {
  return <span className="Caption-small text-smena_text-secondary inline-flex pt-1 max-h-10">{text}</span>;
};
